module.exports = __webpack_public_path__ + "assets/img/Type E (22).618a07f9.jpg";